import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Switch } from '@mui/material';
// import Toggle from '../../components/Toggle';
import MemberNameEmailColumn from '../../components/table/MemberNameEmailColumn';

function ViewActivityTable({
  tableData,
  date,
  handleSelectDate,
  collapseTable,
  setCollapseTable,
  showCaptures,
  setShowCaptures,
  activityType,
  workspaceMember,
}) {
  const {
    firstName,
    lastName,
    email,
    profilePicture,
  } = workspaceMember.user;

  // PTO styling objects
  const ptoStyle = {
    backgroundColor: '#fff3cd',
    borderLeft: '4px solid #ffc107',
    color: '#856404',
  };

  const ptoHeaderStyle = {
    backgroundColor: '#fff8e1',
    borderLeft: '4px solid #ffc107',
  };

  const getProjectColor = (projectName, projectId) => {
    const colors = [
      '#9C27B0',
      '#E91E63',
      '#3F51B5',
      '#2196F3',
      '#00BCD4',
      '#009688',
      '#4CAF50',
      '#8BC34A',
      '#CDDC39',
      '#FF9800',
      '#FF5722',
      '#795548',
    ];

    const index = projectId ? (parseInt(projectId, 10) % colors.length) : (projectName.length % colors.length);
    return colors[index];
  };

  return (
    <>
      <table className="table activity-table" style={{ marginTop: 24 }}>
        <thead>
          <tr className={`${!collapseTable && 'uncollapsed'} table-row`}>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <th scope="col" className="table-cell">
              <MemberNameEmailColumn
                profilePicture={profilePicture}
                firstName={firstName}
                lastName={lastName}
                email={email}
                id={workspaceMember.id}
                component="div"
              />
            </th>
            {tableData.dates?.map((day, index) => (
              <th
                key={index}
                scope="col"
                style={{
                  cursor: 'pointer',
                  ...(tableData.ptoData && tableData.ptoData[index] ? ptoHeaderStyle : {}),
                }}
                className={moment(date).day() === index ? 'selected-date table-cell' : 'table-cell'}
                onClick={() => handleSelectDate(new Date(day), activityType)}
              >
                <div className="dayname-date">{moment(day).date()}</div>
                <div className="subdate-container">
                  <div className="day-date">{moment(day).format('ddd')}</div>
                  <div className="month-date">{moment(day).format('MMM')}</div>
                </div>
                {tableData.ptoData && tableData.ptoData[index] && (
                  <div style={{
                    fontSize: '10px', color: '#856404', fontWeight: 'bold', marginTop: '2px',
                  }}
                  >
                    PTO
                  </div>
                )}
              </th>
            ))}
            <th scope="col" className="table-cell">
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          {tableData.projectTableData && Object.entries(tableData.projectTableData)
            .map(([projectId, projectData]) => {
              const hasTime = projectData.totalSeconds > 0;
              if (!hasTime) return null;

              return (
                <tr key={`project-${projectId}`} className={`${!collapseTable && 'uncollapsed'} table-row`}>
                  {/* First column - Project Name */}
                  <th scope="row" className="table-cell table-header">
                    <div
                      style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        backgroundColor: getProjectColor(projectData.name, projectId),
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        flexShrink: 0,
                      }}
                    >
                      {projectData.name.charAt(0).toUpperCase()}
                    </div>
                    {projectData.name}
                  </th>

                  {/* Time columns for each day */}
                  {projectData.times.map((time, index) => (
                    <td
                      key={index}
                      role="gridcell"
                      style={{
                        cursor: 'pointer',
                        ...(tableData.ptoData && tableData.ptoData[index] ? ptoStyle : {}),
                      }}
                      className={
                      `table-cell table-value ${moment(date).day() === index ? 'selected-date' : ''}`
                    }
                      onClick={() => handleSelectDate(new Date(tableData.dates[index]), activityType)}
                    >
                      <span className="table-value">{time !== '0:00:00' ? time : '-'}</span>
                    </td>
                  ))}

                  {/* Total column */}
                  <td className="table-cell table-value">
                    {projectData.totalTime !== '0:00:00' ? projectData.totalTime : '-'}
                  </td>
                </tr>
              );
            })}
          <tr className={`${!collapseTable && 'uncollapsed'} table-row`}>
            <th scope="row" className="table-cell table-header">Total</th>
            {tableData.times?.map((time, index) => (
              <td
                key={index}
                role="gridcell"
                style={{
                  cursor: 'pointer',
                  ...(tableData.ptoData && tableData.ptoData[index] ? ptoStyle : {}),
                }}
                className={
                  `table-cell table-value ${moment(date).day() === index ? 'selected-date' : ''}`
                }
                onClick={() => handleSelectDate(new Date(tableData.dates[index]), activityType)}
              >
                <span className="table-value">{time}</span>
                {tableData.ptoData && tableData.ptoData[index]
                && tableData.ptoTimes && tableData.ptoTimes[index] && tableData.ptoTimes[index] !== '0:00:00' && (
                  <div style={{ fontSize: '11px', color: '#856404', marginTop: '2px' }}>
                    PTO:
                    {' '}
                    {tableData.ptoTimes[index]}
                  </div>
                )}
              </td>
            ))}
            <td className="table-cell table-value">
              {tableData.totalTime}
              {tableData.totalPtoTime && tableData.totalPtoTime !== '0:00:00' && (
                <div style={{ fontSize: '11px', color: '#856404', marginTop: '2px' }}>
                  PTO:
                  {' '}
                  {tableData.totalPtoTime}
                </div>
              )}
            </td>
          </tr>
          <tr className={`${!collapseTable && 'uncollapsed'} table-row`}>
            <th scope="row" className="table-cell table-header">Avg Activity</th>
            {tableData.avgActivities?.map((avgActivity, index) => (
              <td
                key={index}
                role="gridcell"
                style={{
                  cursor: 'pointer',
                  ...(tableData.ptoData && tableData.ptoData[index] ? ptoStyle : {}),
                }}
                className={
                  `table-cell table-value ${moment(date).day() === index ? 'selected-date' : ''}`
                }
                onClick={() => handleSelectDate(new Date(tableData.dates[index]), activityType)}
              >
                {avgActivity
                  ? (
                    <span className={`
                      ${avgActivity <= 25 ? 'low-activity' : ''}
                      ${avgActivity >= 75 ? 'high-activity' : ''}`}
                    >
                      {`${avgActivity}%`}
                    </span>
                  )
                  : '--%'}
              </td>
            ))}
            <td className="table-cell table-value">
              {tableData.totalAvgActivity
                ? (
                  <span className={`
                    ${tableData.totalAvgActivity <= 25 ? 'low-activity' : ''}
                    ${tableData.totalAvgActivity >= 75 ? 'high-activity' : ''}`}
                  >
                    {`${tableData.totalAvgActivity}%`}
                  </span>
                )
                : '--%'}
            </td>
          </tr>
        </tbody>
      </table>
      <div className="buttons-container">
        <div data-testid="switch">
          <Switch checked={showCaptures} onChange={() => setShowCaptures(!showCaptures)} color="secondary" />
          <span className="switch-label">Show Webcam & Screenshots</span>
        </div>
        {showCaptures && (
        <button
          type="button"
          className="collapse-button"
          data-testid="collapse-button"
          onClick={() => setCollapseTable(!collapseTable)}
        >
            {collapseTable ? (
              <div className="flex-col">
                <div style={{ display: 'flex', justifyContent: 'center', height: 15 }}>
                  <div className="fa fa-caret-down" />
                </div>
                <div style={{ height: 6, borderTop: '2px solid #546077' }} />
              </div>
            ) : (
              <div className="flex-col">
                <div style={{ height: 6, borderBottom: '2px solid #546077' }} />
                <div style={{ display: 'flex', justifyContent: 'center', height: 15 }}>
                  <div className="fa fa-caret-up" />
                </div>
              </div>
            )}
        </button>
        )}
      </div>
    </>
  );
}

ViewActivityTable.propTypes = {
  showCaptures: PropTypes.bool.isRequired,
  setShowCaptures: PropTypes.func.isRequired,
  setCollapseTable: PropTypes.func.isRequired,
  tableData: PropTypes.shape({
    dates: PropTypes.arrayOf(PropTypes.string),
    times: PropTypes.arrayOf(PropTypes.string),
    avgActivities: PropTypes.arrayOf(PropTypes.number),
    totalTime: PropTypes.string,
    totalAvgActivity: PropTypes.number,
    ptoData: PropTypes.arrayOf(PropTypes.bool),
    ptoTimes: PropTypes.arrayOf(PropTypes.string),
    totalPtoTime: PropTypes.string,
  }).isRequired,
  collapseTable: PropTypes.bool,
  date: PropTypes.instanceOf(Date),
  handleSelectDate: PropTypes.func.isRequired,
  activityType: PropTypes.string.isRequired,
  workspaceMember: PropTypes.shape({
    id: PropTypes.number.isRequired,
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

ViewActivityTable.propTypes = {
  showCaptures: PropTypes.bool.isRequired,
  setShowCaptures: PropTypes.func.isRequired,
  setCollapseTable: PropTypes.func.isRequired,
  collapseTable: PropTypes.bool.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  handleSelectDate: PropTypes.func.isRequired,
  activityType: PropTypes.string.isRequired,
  tableData: PropTypes.shape({
    dates: PropTypes.arrayOf(PropTypes.string),
    times: PropTypes.arrayOf(PropTypes.string),
    avgActivities: PropTypes.arrayOf(PropTypes.number),
    totalTime: PropTypes.string,
    totalAvgActivity: PropTypes.number,
    ptoData: PropTypes.arrayOf(PropTypes.bool),
    ptoTimes: PropTypes.arrayOf(PropTypes.string),
    totalPtoTime: PropTypes.string,
    projectTableData: PropTypes.objectOf(PropTypes.shape({
      name: PropTypes.string,
      times: PropTypes.arrayOf(PropTypes.string),
      totalTime: PropTypes.string,
      totalSeconds: PropTypes.number,
    })),
  }).isRequired,
  workspaceMember: PropTypes.shape({
    id: PropTypes.number.isRequired,
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string.isRequired,
      profilePicture: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default ViewActivityTable;
